import { Component, OnDestroy, OnInit, effect, inject } from '@angular/core';
import { BrandingService } from '@approot/branding';
import { AuthService, SSO_SIGNOUT_KEYS } from '@approot/services';
import { PhoenixEventBusService } from '@approot/services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  public authService = inject(AuthService);
  public brand = inject(BrandingService);
  public phxQueue = inject(PhoenixEventBusService);
  public isSSO = false;
  public ssoPortalURL: string;
  public ssoPortalAction = 'link';
  public showDisclaimer = false;

  constructor() {
    effect(() => {
      const disclaimer = this.brand.disclaimer();
      this.showDisclaimer = typeof disclaimer === 'string';
    });
  }

  public ngOnDestroy() {
    setTimeout(async () => {
      await this.authService.currentSession();
      this.phxQueue.addEvent({ type: 'access', category: 'login' });
    }, 0);
  }

  public ngOnInit() {
    // SSO users don't want to see the login form.  This a hack to make it look like a logout page
    this.isSSO = sessionStorage.getItem('isSSO') === 'true';
    this.ssoPortalURL = sessionStorage.getItem('ssoPortalURL');
    this.ssoPortalAction = sessionStorage.getItem('ssoPortalAction') || 'link';

    if (
      this.isSSO &&
      this.ssoPortalURL &&
      this.ssoPortalAction === 'redirect'
    ) {
      this.clearSSOSettings();
      window.location.href = this.ssoPortalURL;
    }

    setTimeout(() => this.clearSSOSettings(), 3000);
  }

  public forceNormalLogin() {
    this.isSSO = false;
  }

  private clearSSOSettings() {
    SSO_SIGNOUT_KEYS.forEach(key => sessionStorage.removeItem(key));
  }
}
